import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  ignoreErrors: [
    'ChunkLoadError' // ignored to reduce noise until we have a proper serviceworker installed
  ]
});

export default Sentry;

